<nz-table 
  #editRowTable  
  nzSize="small"
  nzBordered="true"
  nzOuterBordered="false"
  [nzTotal]="categories.length"
  [nzPageSize]="0"
  [nzPageIndex]="0"
  [nzTemplateMode]="true"
  [nzFrontPagination]="false">
  <thead>
    <tr>
      <th rowSpan="2" nzLeft nzWidth="200px">Grupo</th>
      <th nzWidth="80px" rowSpan="2">Cantidad</th>
      <th colspan="{{ planPeriod.mealTimes.length + 1 }}">Tiempos de comida</th>
    </tr>
    <tr>
      <th nzLeft nzWidth="50px" *ngFor="let mealTime of planPeriod.mealTimes; let i = index">
        <div class="period-header">
          <nz-form-item *ngIf="mealTime.editMode" class="form-item-compact">
            <nz-form-control [nzErrorTip]="'Period name cannot be empty'">
              <input 
                nz-input 
                nzBorderless
                #editableInput
                [(ngModel)]="mealTime.title" 
                (blur)="saveMealTimeTitle(i)"
                class="edit-input" 
                [ngClass]="{'has-error': mealTime.hasError}"
                required 
              />
            </nz-form-control>
          </nz-form-item>
          <span *ngIf="!mealTime.editMode" class="period-title" (click)="editMealTime(i)"> {{ mealTime.title }}</span>
          <div class="icon-container">
            <i nz-icon nzType="edit" nzTheme="outline" (click)="editMealTime(i)" *ngIf="!mealTime.editMode"></i>
            <i nz-icon nzType="save" nzTheme="outline" (click)="saveMealTimeTitle(i)" *ngIf="mealTime.editMode"></i>
            <i nz-icon nzType="delete" nzTheme="outline" (click)="deleteMealTime(i)"></i>
          </div>
        </div>
      </th>
      <th nzWidth="50px" class="add-period-column" (click)="addMealTime()">
        <i nz-icon nzType="plus" nzTheme="outline" class="add-period-icon"></i>
      </th>
    </tr>
  </thead>
  <tbody>
    <ng-container *ngFor="let category of categories; let i = index">
      <tr *ngIf="planPeriod.metadata?.nutrientTable && planPeriod.metadata.nutrientTable[category._id]">
        <td>
          {{ category.name }}
          <br>
          <nz-progress [nzPercent]="getAssignedPercentage(category._id)" [nzStatus]="getCategoryStatus(category._id)" nzStrokeColor="#1890ff"></nz-progress>
        </td>
        <td class="tw-text-center">
          {{ getTotalNutrient(category._id) }} / {{ planPeriod.metadata.nutrientTable[category._id] }}
        </td>
        <td *ngFor="let mealTime of planPeriod.mealTimes; let i = index">
          <nz-input-number nzBorderless [nzMin]="0" [nzMax]="getMaxValueForInput(category._id, mealTime.metadata.nutrientTable[category._id])" [(ngModel)]="mealTime.metadata.nutrientTable[category._id]" [ngClass]="{'invalid': !isSumValid(category._id)}" />
        </td>
      </tr>
    </ng-container>
  </tbody>
</nz-table>
